<i18n locale="en">
{
  "title": "Logo",
  "favicon": "Favicon",
  "logoUpscaledTransparent": "Upscaled Transparent Logo",
  "logoDark": "Dark Logo",
  "logoLight": "Light Logo"
}
</i18n>

<template>
  <OwnInputContainer :label="t('favicon')">
    <ImageInput
      :model-value="brandFavicon"
      file-type="png"
      @update:model-value="onFaviconUpdate"
    />
  </OwnInputContainer>
  <OwnInputContainer :label="t('title')">
    <ImageInput
      :model-value="brandLogo"
      file-type="png"
      @update:model-value="onImageUpdate"
    />
  </OwnInputContainer>
  <OwnInputContainer :label="t('logoUpscaledTransparent')">
    <ImageInput
      :model-value="brandLogoUpscaledTransparent"
      file-type="png"
      @update:model-value="onLogoUpscaledTransparentUpdate"
    />
  </OwnInputContainer>
  <OwnInputContainer :label="t('logoDark')">
    <ImageInput
      :model-value="brandLogoDark"
      file-type="png"
      @update:model-value="onLogoDarkUpdate"
    />
  </OwnInputContainer>
  <OwnInputContainer :label="t('logoLight')">
    <ImageInput
      :model-value="brandLogoLight"
      file-type="png"
      @update:model-value="onLogoLightUpdate"
    />
  </OwnInputContainer>
</template>

<script>
import set from 'lodash/set'
import { useI18n } from 'vue-i18n'
import { mapActions, mapGetters } from 'vuex'

import { ImageInput } from '@/components/inputs/ImageInput'
import { OwnInputContainer } from '@/ui/OwnInputContainer'

export default {
  name: 'LogoEditor',
  components: {
    ImageInput,
    OwnInputContainer,
  },
  setup() {
    const { t } = useI18n()

    return { t }
  },
  computed: {
    ...mapGetters({
      currentResource: 'websiteBuilder/currentResource',
    }),
    brandFavicon() {
      const { currentResource } = this

      return currentResource?.brand?.assets?.favicon
    },
    brandLogo() {
      const { currentResource } = this

      return currentResource?.brand?.assets?.logo
    },
    brandLogoDark() {
      const { currentResource } = this

      return currentResource?.brand?.assets?.logoDark
    },
    brandLogoLight() {
      const { currentResource } = this

      return currentResource?.brand?.assets?.logoLight
    },
    brandLogoUpscaledTransparent() {
      const { currentResource } = this

      return currentResource?.brand?.assets?.logoUpscaledTransparent
    },
  },
  methods: {
    ...mapActions({
      updateResource: 'websiteBuilder/updateResource',
    }),
    async onFaviconUpdate(newImage) {
      const update = set({}, 'brand.assets.favicon', newImage)

      await this.updateResource(update)
    },
    async onImageUpdate(newImage) {
      const update = set({}, 'brand.assets.logo', newImage)

      await this.updateResource(update)
    },
    async onLogoDarkUpdate(newImage) {
      const update = set({}, 'brand.assets.logoDark', newImage)

      await this.updateResource(update)
    },
    async onLogoLightUpdate(newImage) {
      const update = set({}, 'brand.assets.logoLight', newImage)

      await this.updateResource(update)
    },
    async onLogoUpscaledTransparentUpdate(newImage) {
      const update = set({}, 'brand.assets.logoUpscaledTransparent', newImage)

      await this.updateResource(update)
    },
  },
}
</script>
